export enum Feature {
    AlternativePointsDisplay = 'alternative-points-display',
    AskPostQuestion = 'ask-post-question',
    AskShowQuestions = 'ask-show-questions',
    AutoCompleterDestination = 'auto-completer-destination',
    C24Community = 'c24-community',
    C24PointsCashbackToggle = 'c24-points-cashback-toggle',
    CashbackBanner = 'cashback-banner',
    Chatty = 'chatty',
    ChattySqa = 'chatty-sqa',
    CheckGpt = 'checkgpt_desktop',
    CSI = 'checkout-speed-increase-desktop',
    CustomerChampionAward = 'customer-champion-award',
    EarlybirdPriceAttack = 'earlybird-price-attack',
    EarlybirdSeason = 'earlybird-season',
    LastminuteSeason = 'lastminute-season',
    EffectivePrice = 'effective-price',
    EntryRestriction = 'entry-restriction',
    FilterPromotionalDiscount = 'filter-promotional-discount',
    HibOnPage = 'hib-on-page',
    HotelContentSearch = 'hotel-content-search',
    HotelHotelToggle = 'hotel-hotel-toggle',
    HotelMap = 'hotel-map',
    IndividualTravelSpotWidgets = 'individual-travel-spot-widgets',
    IndividualTravelWidgets = 'individual-travel-widgets',
    KillS2 = 'kill-step2',
    KillSticky = 'kill-sticky-wireframe',
    S3KiFilter = 's3-ki-filter',
    Leaflet = 'leaflet',
    ManualFilterSubmit = 'manual-filter-submit',
    NoFilterPrices = 'no-filter-prices',
    PriceOverviewTooltip = 'price-overview-tooltip',
    PriceTree = 'price-tree',
    PromotionalDiscountLandingPageBlackFriday = 'promotional-discount-landing-page-black-friday',
    PromotionalDiscountSearchForm = 'promotional-discount-search-form',
    PromotionalVoucher = 'promotional-voucher',
    PromotionalVoucherActivation = 'promotional-voucher-activation',
    RepositioningFlexFilterAfterPopular = 'repositioning-flex-filter-after-popular',
    RepositioningFlexFilterAfterPriceSlider = 'repositioning-flex-filter-after-price-slider',
    RoomContent = 'detailed-room-content',
    S1CmxFormular = 's1-cmx-formular',
    S1S4Mandatory = 's1-s4-mandatory',
    S3HotelListDeviced = 's3-hotel-list-deviced',
    S3LoginBanner = 's3-login-banner',
    S3Nudging = 's3-nudging',
    S3S4StiftungWarentestBanner = 's3-s4-stiftung-warentest-banner-desktop',
    S3S4WordingAdjustmentDesktop = 's3-s4-wording-adjustments-desktop',
    S3SemHotelEntry = 's3-sem-hotel-entry',
    S3AccommodationCategoryGroupFilter = 's3-accommodation-category-group-filter',
    S4CmxToggle = 's4-cmx-toggle',
    S4LoginBanner = 's4-login-banner',
    S4RefreshTop = 's4-refresh-top',
    S4ReactRefreshTop = 's4-react-refresh-top',
    S5RepositioningPriceDetails = 's5-repositioning-price-details',
    SearchForNoBag = 'search-for-no-bag',
    S5TransferMultiOption = 's5-transfer-multi-option',
    SingleLineSearchform = 'single-line-searchform',
    Sentry = 'sentry',
    SemRedesignC24HotelStyle = 'sem-redesign-c24-hotel-style',
    SeaVoucher = 'sea-voucher',
    XCountAppSplashScreen = 'x-count-app-splash-screen',
    SplitMapInitiallyOpened = 'split-map-initially-opened',
    TargetBlankAvailable = 'target-blank-available',
    TransparencyInitiative = 'transparency-initiative',
    TravelExpertRecall = 'travel-expert-recall',
    TravelExpertsChatBot = 'travel-experts-chatbot',
    TrustElements = 'trust-elements',
}
